import { Component, Input, output } from '@angular/core'
import { IBvUser } from '@modules/bv-api'
import { DialogService } from '../../dialogs'
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component'
import { MatMenuTrigger, MatMenu } from '@angular/material/menu'
import { FeatherModule } from 'angular-feather'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'bv-comment',
  template: `
    <div class="flex flex-row border-b border-gray-200 px-5 py-4">
      <user-avatar [firstName]="comment.creatorName"></user-avatar>
      <div class="ml-3 relative w-full">
        <div class="font-semibold mb-1 ">{{ comment.creatorName }}</div>
        <div class="text-gray-500 mb-1 text-xs">
          {{ comment.dateCreated | date: 'MMM d' }} at {{ comment.dateCreated | date: 'h:mm a' }}
        </div>
        <div class="py-1 text-gray-600">
          {{ comment.value }}
        </div>

        @if (canEdit) {
          <div [mat-menu-trigger-for]="optionsMenu" class="absolute top-1/2 right-5 -translate-y-1/2">
            <i-feather name="menu"></i-feather>
          </div>
        }
        <mat-menu #optionsMenu="matMenu">
          <div class="bv-menu">
            <div class="menu-item" (click)="_onDelete()">Delete</div>
          </div>
        </mat-menu>
      </div>
    </div>
  `,
  imports: [UserAvatarComponent, MatMenuTrigger, FeatherModule, MatMenu, DatePipe],
})
export class BvCommentComponent {
  message = ''
  mentions = []

  @Input() comment
  @Input() user: IBvUser
  @Input() users: IBvUser[]

  readonly onUpdate = output<{
    id: string
    message: string
    mentions: string[]
  }>()
  readonly onDelete = output<{
    id: string
  }>()

  constructor(private dialogService: DialogService) {}

  get canEdit() {
    return this.user.id == this.comment.createdBy
  }

  get editing() {
    return !!this.message
  }

  stopEvent(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  onMessageChange($event) {
    this.message = $event.message
    this.mentions = $event.mentions
  }

  onEditRequest() {
    this.message = this.comment.value
  }

  onUpdateRequest() {
    this.dialogService.confirmDialog(
      undefined,
      `Are you sure you want to update the comment.`,
      'Save',
      'success',
      undefined,
      (err, confirm) => {
        if (!confirm) return

        this.onUpdate.emit({ id: this.comment.id, message: this.message, mentions: this.mentions })
        this.onCancelRequest()
      },
    )
  }

  _onDelete() {
    this.dialogService.confirmDialog(
      undefined,
      `Your note will be removed forever. This action cannot be undone.`,
      'Delete',
      'warning',
      undefined,
      (err, confirm) => {
        if (!confirm) return

        this.onDelete.emit({ id: this.comment.id })
      },
    )
  }

  onCancelRequest() {
    this.message = undefined
    this.mentions = undefined
  }
}
